import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/list/[khatmId]/components/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default","error"] */ "/app/node_modules/react-hot-toast/dist/index.mjs");
